<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import normalPrint from "./normal/index.vue";

@Component({
  name: "preformed-invoice",
  components: {
    normalPrint
  }
})
export default class App extends Vue {
  render(h) {
    return (
      <div class="preformed-invoice">
        <normal-print></normal-print>
      </div>
    );
  }
}
</script>

<style scoped>
.preformed-invoice {
  background: #fff;
}
</style>
